(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.announcement-bar').forEach(function (bar) {
      var items = bar.querySelectorAll('[data-announcement-item]');
      if (items.length < 2) return;

      var interval = parseInt(bar.dataset.rotateMs, 10) || 5000;
      var mobile = window.matchMedia('(max-width: 767px)');
      var timer = null;
      var index = 0;

      function show(target) {
        for (var i = 0; i < items.length; i++) {
          if (i === target) {
            items[i].setAttribute('data-active', '');
          } else {
            items[i].removeAttribute('data-active');
          }
        }
      }

      function start() {
        if (timer) return;
        timer = setInterval(function () {
          index = (index + 1) % items.length;
          show(index);
        }, interval);
      }

      function stop() {
        clearInterval(timer);
        timer = null;
        index = 0;
        show(0);
      }

      // Alleen roteren waar er ruimte is voor een regel; op desktop staan ze naast elkaar.
      function sync() {
        if (mobile.matches) {
          start();
        } else {
          stop();
        }
      }

      mobile.addEventListener('change', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function() {
  const cartForm = document.getElementById('cart-form');
  if (!cartForm) return;

  // Handle quantity changes
  document.querySelectorAll('.quantity-selector__btn').forEach(btn => {
    btn.addEventListener('click', async function() {
      const action = this.dataset.action;
      const key = this.dataset.key;
      const input = document.querySelector(`input[data-key="${key}"]`);
      let quantity = parseInt(input.value);

      if (action === 'increase') {
        quantity++;
      } else if (action === 'decrease' && quantity > 0) {
        quantity--;
      }

      input.value = quantity;
      await updateCart(key, quantity);
    });
  });

  // Handle input changes
  document.querySelectorAll('.quantity-selector__input').forEach(input => {
    let debounceTimer;
    input.addEventListener('change', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(async () => {
        const key = this.dataset.key;
        const quantity = parseInt(this.value) || 0;
        await updateCart(key, quantity);
      }, 300);
    });
  });

  // Handle remove
  document.querySelectorAll('[data-action="remove"]').forEach(btn => {
    btn.addEventListener('click', async function() {
      const key = this.dataset.key;
      await updateCart(key, 0);
    });
  });

  // Show cart error notification
  function showCartError(message) {
    var existing = document.querySelector('.cart-page__error');
    if (existing) existing.remove();

    var errorEl = document.createElement('div');
    errorEl.className = 'cart-page__error';

    var textEl = document.createElement('span');
    textEl.textContent = message;

    errorEl.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>';
    errorEl.appendChild(textEl);

    var header = document.querySelector('.cart-page__header');
    if (header) {
      header.insertAdjacentElement('afterend', errorEl);
    }

    setTimeout(function() {
      if (errorEl.parentNode) {
        errorEl.classList.add('cart-page__error--hiding');
        setTimeout(function() { errorEl.remove(); }, 300);
      }
    }, 5000);
  }

  // Update cart via AJAX
  async function updateCart(key, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        const message = errorData && (errorData.description || errorData.message);
        showCartError(message || 'Kon aantal niet wijzigen');
        // Reset input to current server value
        const input = document.querySelector('input[data-key="' + key + '"]');
        if (input) {
          const cartData = await fetch('/cart.js').then(r => r.json()).catch(() => null);
          if (cartData && cartData.items) {
            const item = cartData.items.find(i => i.key === key);
            if (item) input.value = item.quantity;
          }
        }
        return;
      }

      // Reload page to show updated cart
      window.location.reload();
    } catch (error) {
      console.error('Error updating cart:', error);
      showCartError('Er is een fout opgetreden. Probeer het opnieuw.');
    }
  }

  // Cart Recommendations - async loading
  const cartRecsContainer = document.getElementById('cart-recommendations');
  if (cartRecsContainer && cartRecsContainer.dataset.url) {
    fetch(cartRecsContainer.dataset.url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const recommendations = doc.getElementById('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim()) {
          cartRecsContainer.innerHTML = recommendations.innerHTML;
          initCartRecsScroll();
        }
      })
      .catch(err => console.error('Error loading cart recommendations:', err));
  }

  // Cart Recommendations scroll arrows
  function initCartRecsScroll() {
    const recScroll = document.getElementById('cart-rec-scroll');
    const recArrowLeft = document.querySelector('.cart-rec-arrow--left');
    const recArrowRight = document.querySelector('.cart-rec-arrow--right');

    if (!recScroll || !recArrowLeft || !recArrowRight) return;

    function getScrollAmount() {
      const card = recScroll.querySelector('.cart-rec-card');
      return card ? card.offsetWidth + 16 : 200;
    }

    function updateRecArrows() {
      const maxScroll = recScroll.scrollWidth - recScroll.clientWidth;
      recArrowLeft.disabled = recScroll.scrollLeft <= 0;
      recArrowRight.disabled = recScroll.scrollLeft >= maxScroll - 1;
    }

    recArrowLeft.addEventListener('click', () => {
      recScroll.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
      setTimeout(updateRecArrows, 350);
    });

    recArrowRight.addEventListener('click', () => {
      recScroll.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
      setTimeout(updateRecArrows, 350);
    });

    recScroll.addEventListener('scroll', () => {
      clearTimeout(recScroll.scrollTimeout);
      recScroll.scrollTimeout = setTimeout(updateRecArrows, 100);
    });

    updateRecArrows();
  }

  // Shipping Rate Calculator
  var shippingCalc = document.getElementById('shipping-calc');
  var shippingCountry = document.getElementById('shipping-calc-country');
  var shippingZip = document.getElementById('shipping-calc-zip');
  var shippingBtn = document.getElementById('shipping-calc-btn');
  var shippingResults = document.getElementById('shipping-calc-results');

  if (shippingCalc && shippingCountry && shippingZip && shippingBtn && shippingResults) {
    function getZip() {
      // Only ever send the postcode the customer actually typed. Never fall back
      // to a default/store postcode, otherwise the rate request would persist the
      // store address into the cart session and prefill it at checkout.
      return shippingZip.value.trim();
    }

    function buildUrl() {
      return '/cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(getZip()) + '&shipping_address[country]=' + encodeURIComponent(shippingCountry.value);
    }

    shippingCountry.addEventListener('change', function() {
      var selected = this.options[this.selectedIndex];
      shippingZip.value = selected.dataset.zip || '';
      shippingCalc.dataset.url = buildUrl();
      fetchShippingRates();
    });

    shippingBtn.addEventListener('click', function() {
      shippingCalc.dataset.url = buildUrl();
      fetchShippingRates();
    });

    shippingZip.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        shippingCalc.dataset.url = buildUrl();
        fetchShippingRates();
      }
    });

    async function fetchShippingRates() {
      // Without a postcode the rates endpoint answers 422, so asking at all only
      // produces a red error next to the checkout button. Prompt instead.
      if (!getZip()) {
        shippingResults.hidden = false;
        shippingResults.innerHTML = '<p class="shipping-calc__hint"></p>';
        shippingResults.firstChild.textContent = shippingCalc.dataset.zipHint || '';
        return;
      }

      var url = shippingCalc.dataset.url;
      if (!url) {
        url = buildUrl();
        shippingCalc.dataset.url = url;
      }

      shippingBtn.disabled = true;
      shippingResults.hidden = false;
      shippingResults.innerHTML = '<p class="shipping-calc__loading">' + (document.documentElement.lang === 'nl' ? 'Verzendkosten berekenen\u2026' : 'Calculating rates\u2026') + '</p>';

      try {
        var response = await fetch(url);

        if (!response.ok) {
          var errorData = await response.json().catch(function() { return null; });
          var errorMsg = errorData && errorData.errors ? Object.values(errorData.errors).flat().join(', ') : (document.documentElement.lang === 'nl' ? 'Kan verzendkosten niet berekenen voor dit adres' : 'Unable to calculate shipping for this address');
          shippingResults.innerHTML = '<p class="shipping-calc__error">' + errorMsg + '</p>';
          return;
        }

        var data = await response.json();
        var rates = data.shipping_rates || [];

        if (rates.length === 0) {
          shippingResults.innerHTML = '<p class="shipping-calc__error">' + (document.documentElement.lang === 'nl' ? 'Geen verzendopties beschikbaar voor dit adres' : 'No shipping options available for this address') + '</p>';
          return;
        }

        var cheapest = rates.reduce(function(min, r) {
          return parseFloat(r.price) < parseFloat(min.price) ? r : min;
        }, rates[0]);
        var price = parseFloat(cheapest.price);
        var isNl = document.documentElement.lang === 'nl';
        var formatted = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(price);
        var text = price === 0
          ? (isNl ? 'Gratis verzending' : 'Free shipping')
          : (isNl ? 'Verzendkosten vanaf ' + formatted : 'Shipping from ' + formatted);
        var cls = price === 0 ? 'shipping-calc__result shipping-calc__result--free' : 'shipping-calc__result';
        shippingResults.innerHTML = '<p class="' + cls + '">' + text + '</p>';
      } catch (error) {
        shippingResults.innerHTML = '<p class="shipping-calc__error">' + (document.documentElement.lang === 'nl' ? 'Er is een fout opgetreden. Probeer het opnieuw.' : 'An error occurred. Please try again.') + '</p>';
      } finally {
        shippingBtn.disabled = false;
      }
    }

    // No auto-fetch on load: the postcode is empty then, and asking anyway
    // renders an error the visitor did nothing to cause.
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function() {
  const filterToggle = document.getElementById('filter-toggle');
  const filterDrawer = document.getElementById('filter-drawer');
  const filterForm = document.getElementById('filter-form');
  const filterClose = filterDrawer?.querySelector('.filter-drawer__close');
  const filterOverlay = filterDrawer?.querySelector('.filter-drawer__overlay');
  const applyBtn = filterDrawer?.querySelector('.filter-drawer__apply');

  function openFilters() {
    if (!filterDrawer) return;
    filterDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    if (!filterDrawer) return;
    filterDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Show loading state and submit form
  function submitFilters() {
    if (!filterForm) return;
    filterDrawer?.classList.add('filter-drawer--loading');
    filterForm.submit();
  }

  filterToggle?.addEventListener('click', openFilters);
  filterClose?.addEventListener('click', closeFilters);
  filterOverlay?.addEventListener('click', closeFilters);

  // Checkbox filters: apply immediately on change
  filterDrawer?.querySelectorAll('.filter-option__checkbox').forEach(checkbox => {
    checkbox.addEventListener('change', submitFilters);
  });

  // Price range filters: apply on Enter key or blur with debounce
  let priceDebounce = null;
  filterDrawer?.querySelectorAll('.filter-price__input').forEach(input => {
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        submitFilters();
      }
    });
    input.addEventListener('change', () => {
      clearTimeout(priceDebounce);
      priceDebounce = setTimeout(submitFilters, 800);
    });
  });

  // Apply button submits the form (fallback for price range)
  applyBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    submitFilters();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && filterDrawer?.getAttribute('aria-hidden') === 'false') {
      closeFilters();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  var SHOP_ID = '1219387';
  var PUBLIC_CODE = '7c925fab21b2e8ad6cde6bfb73bebdd8a0108273bb14810b43c4ce53b0c393d8';
  var SUMMARY_URL = 'https://dashboard.webwinkelkeur.nl/api/1.0/ratings_summary.json?id=' + SHOP_ID + '&public_code=' + PUBLIC_CODE + '&language=nl';
  var REVIEWS_URL = 'https://dashboard.webwinkelkeur.nl/api/1.0/ratings.json?id=' + SHOP_ID + '&public_code=' + PUBLIC_CODE + '&limit=25';

  var CACHE_PREFIX = 'cr2_';
  var CACHE_DURATION = 3600000; // 1 hour

  // Clear old cache entries
  try { localStorage.removeItem('cr_summary'); localStorage.removeItem('cr_reviews'); } catch (e) { /* ignore */ }

  function getCached(key) {
    try {
      var cached = localStorage.getItem(CACHE_PREFIX + key);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (Date.now() - parsed.timestamp < CACHE_DURATION) {
          return parsed.data;
        }
      }
    } catch (e) { /* ignore */ }
    return null;
  }

  function setCache(key, data) {
    try {
      localStorage.setItem(CACHE_PREFIX + key, JSON.stringify({
        data: data,
        timestamp: Date.now()
      }));
    } catch (e) { /* ignore */ }
  }

  var STAR_PATH = 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z';

  function starSVG(cls) {
    return '<svg class="' + cls + '" viewBox="0 0 24 24"><path d="' + STAR_PATH + '"/></svg>';
  }

  function generateStars5(rating) {
    var full = Math.floor(rating);
    var partial = rating - full;
    var empty = 5 - full - (partial > 0 ? 1 : 0);
    var gradientId = 'cr-grad-' + Math.random().toString(36).substr(2, 6);
    var html = '';

    if (partial > 0) {
      html += '<svg width="0" height="0" style="position:absolute"><defs>';
      html += '<linearGradient id="' + gradientId + '">';
      html += '<stop offset="' + (partial * 100) + '%" stop-color="#f5a623"/>';
      html += '<stop offset="' + (partial * 100) + '%" stop-color="#e0e0e0"/>';
      html += '</linearGradient></defs></svg>';
    }

    for (var i = 0; i < full; i++) {
      html += starSVG('customer-reviews__star customer-reviews__star--filled');
    }
    if (partial > 0) {
      html += '<svg class="customer-reviews__star" viewBox="0 0 24 24"><path fill="url(#' + gradientId + ')" d="' + STAR_PATH + '"/></svg>';
    }
    for (var j = 0; j < empty; j++) {
      html += starSVG('customer-reviews__star customer-reviews__star--empty');
    }
    return html;
  }

  function generateStarsFromRating(ratingOutOf5) {
    var html = '';
    for (var i = 0; i < 5; i++) {
      if (i < ratingOutOf5) {
        html += starSVG('customer-reviews__star customer-reviews__star--filled');
      } else {
        html += starSVG('customer-reviews__star customer-reviews__star--empty');
      }
    }
    return html;
  }

  function timeAgo(dateStr, t) {
    var then = new Date(dateStr);
    var now = new Date();
    var diffMs = now - then;
    var diffMin = Math.floor(diffMs / 60000);
    var diffHr = Math.floor(diffMs / 3600000);
    var diffDay = Math.floor(diffMs / 86400000);
    var diffWeek = Math.floor(diffDay / 7);

    if (diffMin < 1) return t.justNow;
    if (diffMin < 60) return t.minutesAgo.replace('{{ count }}', diffMin);
    if (diffHr < 24) return (diffHr === 1 ? t.hourAgo : t.hoursAgo).replace('{{ count }}', diffHr);
    if (diffDay < 7) return (diffDay === 1 ? t.dayAgo : t.daysAgo).replace('{{ count }}', diffDay);
    return (diffWeek === 1 ? t.weekAgo : t.weeksAgo).replace('{{ count }}', diffWeek);
  }

  function getRatingLabel(score, t) {
    if (score >= 9) return t.excellent;
    if (score >= 8) return t.veryGood;
    if (score >= 6) return t.good;
    return t.average;
  }

  var VERIFIED_SVG = '<svg class="customer-reviews__card-verified" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<circle cx="12" cy="12" r="10" fill="#1976D2"/>' +
    '<path d="M9 12l2 2 4-4" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function init() {
    var container = document.getElementById('customer-reviews');
    if (!container) return;

    var minStars = parseInt(container.dataset.minStars, 10) || 4;
    var maxReviews = parseInt(container.dataset.maxReviews, 10) || 20;
    var scroll = document.getElementById('customer-reviews-scroll');
    var arrowLeft = container.querySelector('.customer-reviews__arrow--left');
    var arrowRight = container.querySelector('.customer-reviews__arrow--right');
    var progressBar = container.querySelector('[data-cr-progress]');

    var t = {
      justNow: container.dataset.tJustNow || 'Just now',
      minutesAgo: container.dataset.tMinutesAgo || '{{ count }} minutes ago',
      hoursAgo: container.dataset.tHoursAgo || '{{ count }} hours ago',
      hourAgo: container.dataset.tHourAgo || '{{ count }} hour ago',
      daysAgo: container.dataset.tDaysAgo || '{{ count }} days ago',
      dayAgo: container.dataset.tDayAgo || '{{ count }} day ago',
      weeksAgo: container.dataset.tWeeksAgo || '{{ count }} weeks ago',
      weekAgo: container.dataset.tWeekAgo || '{{ count }} week ago',
      excellent: container.dataset.tExcellent || 'Excellent',
      veryGood: container.dataset.tVeryGood || 'Very good',
      good: container.dataset.tGood || 'Good',
      average: container.dataset.tAverage || 'Average',
      basedOn: container.dataset.tBasedOn || '{{ count }} reviews',
      verified: container.dataset.tVerified || 'Verified',
      noReviews: container.dataset.tNoReviews || 'No reviews yet'
    };

    function updateArrows() {
      if (!scroll || !arrowLeft || !arrowRight) return;
      var maxScroll = scroll.scrollWidth - scroll.clientWidth;
      arrowLeft.disabled = scroll.scrollLeft <= 0;
      arrowRight.disabled = scroll.scrollLeft >= maxScroll - 1;
    }

    function updateProgress() {
      if (!scroll || !progressBar) return;
      var maxScroll = scroll.scrollWidth - scroll.clientWidth;
      if (maxScroll <= 0) {
        progressBar.style.width = '100%';
        return;
      }
      var pct = ((scroll.scrollLeft + scroll.clientWidth) / scroll.scrollWidth) * 100;
      progressBar.style.width = Math.min(pct, 100) + '%';
    }

    function getScrollAmount() {
      var card = scroll.querySelector('.customer-reviews__card:not(.customer-reviews__card--skeleton)');
      if (!card) card = scroll.querySelector('.customer-reviews__card');
      return card ? card.offsetWidth + 16 : 240;
    }

    if (arrowLeft) {
      arrowLeft.addEventListener('click', function() {
        scroll.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
        setTimeout(function() { updateArrows(); updateProgress(); }, 350);
      });
    }

    if (arrowRight) {
      arrowRight.addEventListener('click', function() {
        scroll.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
        setTimeout(function() { updateArrows(); updateProgress(); }, 350);
      });
    }

    if (scroll) {
      scroll.addEventListener('scroll', function() {
        clearTimeout(scroll._crTimeout);
        scroll._crTimeout = setTimeout(function() { updateArrows(); updateProgress(); }, 100);
      });
    }

    function renderSummary(data) {
      var avg = data.rating_average;
      var count = data.amount;
      var starsRating = (avg / 10) * 5;
      var displayScore = (Math.round(avg * 10) / 10).toFixed(1).replace('.', ',');

      var starsEl = container.querySelector('[data-cr-summary-stars]');
      var scoreEl = container.querySelector('[data-cr-summary-score]');
      var labelEl = container.querySelector('[data-cr-summary-label]');
      var countEl = container.querySelector('[data-cr-summary-count]');

      if (starsEl) starsEl.innerHTML = generateStars5(starsRating);
      if (scoreEl) scoreEl.textContent = displayScore;
      if (labelEl) labelEl.textContent = getRatingLabel(avg, t);
      if (countEl) countEl.textContent = t.basedOn.replace('{{ count }}', count);
    }

    function renderReviews(reviews) {
      if (!Array.isArray(reviews)) {
        reviews = (reviews && reviews.ratings) ? reviews.ratings : [];
      }
      var filtered = reviews.filter(function(r) { return r.rating >= minStars && r.comment && r.comment.trim() !== ''; });
      var limited = filtered.slice(0, maxReviews);

      // Remove skeleton cards
      var skeletons = scroll.querySelectorAll('.customer-reviews__card--skeleton');
      skeletons.forEach(function(s) { s.remove(); });

      if (limited.length === 0) {
        var emptyCard = document.createElement('div');
        emptyCard.className = 'customer-reviews__card';
        emptyCard.innerHTML = '<p class="customer-reviews__card-text">' + t.noReviews + '</p>';
        scroll.appendChild(emptyCard);
      } else {
        limited.forEach(function(review) {
          var card = document.createElement('div');
          card.className = 'customer-reviews__card';

          var starsHtml = generateStarsFromRating(review.rating);
          var timeText = (review.date || review.created_at) ? timeAgo(review.date || review.created_at, t) : '';
          var reviewText = review.comment || '';

          card.innerHTML =
            '<div class="customer-reviews__card-stars-row">' +
              '<div class="customer-reviews__card-stars">' + starsHtml + '</div>' +
              VERIFIED_SVG +
            '</div>' +
            '<div class="customer-reviews__card-time">' + timeText + '</div>' +
            '<div class="customer-reviews__card-text">' + reviewText.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</div>';

          scroll.appendChild(card);
        });
      }

      updateArrows();
      updateProgress();
    }

    // Fetch data
    var cachedSummary = getCached('summary');
    var cachedReviews = getCached('reviews');

    if (cachedSummary && cachedReviews) {
      renderSummary(cachedSummary);
      renderReviews(cachedReviews);
      return;
    }

    var summaryPromise = cachedSummary
      ? Promise.resolve({ data: cachedSummary })
      : fetch(SUMMARY_URL).then(function(r) { return r.json(); });

    var reviewsPromise = cachedReviews
      ? Promise.resolve({ data: cachedReviews })
      : fetch(REVIEWS_URL).then(function(r) { return r.json(); });

    Promise.all([summaryPromise, reviewsPromise])
      .then(function(results) {
        var summaryResult = results[0];
        var reviewsResult = results[1];

        var summaryData = summaryResult.data || summaryResult;
        var reviewsData = reviewsResult.ratings || reviewsResult.data || reviewsResult;

        if (!cachedSummary && summaryData) setCache('summary', summaryData);

        var reviewsList = Array.isArray(reviewsData) ? reviewsData : [];
        if (!cachedReviews && reviewsList.length > 0) setCache('reviews', reviewsList);

        renderSummary(summaryData);
        renderReviews(reviewsList);
      })
      .catch(function(err) {
        console.warn('Customer reviews fetch failed:', err);
        renderSummary({ rating_average: 8.8, amount: 267 });
        var skeletons = scroll.querySelectorAll('.customer-reviews__card--skeleton');
        skeletons.forEach(function(s) { s.remove(); });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.faq-page');
  if (!section) return;

  var items = section.querySelectorAll('.faq-page__item');

  items.forEach(function(item) {
    var question = item.querySelector('.faq-page__question');
    var answer = item.querySelector('.faq-page__answer');
    if (!question || !answer) return;

    question.addEventListener('click', function() {
      var isOpen = item.dataset.open === 'true';

      /* Close all others */
      items.forEach(function(other) {
        if (other !== item) {
          other.dataset.open = 'false';
          var btn = other.querySelector('.faq-page__question');
          if (btn) btn.setAttribute('aria-expanded', 'false');
          var ans = other.querySelector('.faq-page__answer');
          if (ans) ans.hidden = true;
        }
      });

      /* Toggle current */
      item.dataset.open = isOpen ? 'false' : 'true';
      question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      answer.hidden = isOpen;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Mega Nav handlers (cart drawer handled by inline script)
  document.addEventListener('click', function(e) {
    // Close mega panels on click outside
    if (!e.target.closest('.mega-nav__item--has-dropdown') && !e.target.closest('.mega-panel__content')) {
      document.querySelectorAll('.mega-nav__item--active').forEach(item => {
        item.classList.remove('mega-nav__item--active');
        const link = item.querySelector('.mega-nav__link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }

    // Close mega panel when clicking overlay
    if (e.target.closest('.mega-panel__overlay')) {
      document.querySelectorAll('.mega-nav__item--active').forEach(item => {
        item.classList.remove('mega-nav__item--active');
        const link = item.querySelector('.mega-nav__link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Keyboard - close mega panels on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.mega-nav__item--active').forEach(item => {
        item.classList.remove('mega-nav__item--active');
        const link = item.querySelector('.mega-nav__link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Desktop Mega Navigation - Hover events (need direct attachment)
  function initMegaNav() {
    document.querySelectorAll('.mega-nav__item--has-dropdown').forEach(item => {
      const link = item.querySelector('.mega-nav__link');
      if (!link) return;

      item.addEventListener('mouseenter', () => {
        document.querySelectorAll('.mega-nav__item--active').forEach(i => {
          i.classList.remove('mega-nav__item--active');
          const l = i.querySelector('.mega-nav__link');
          if (l) l.setAttribute('aria-expanded', 'false');
        });
        item.classList.add('mega-nav__item--active');
        link.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('mouseleave', () => {
        item.classList.remove('mega-nav__item--active');
        link.setAttribute('aria-expanded', 'false');
      });

      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const isActive = item.classList.contains('mega-nav__item--active');
          document.querySelectorAll('.mega-nav__item--active').forEach(i => {
            i.classList.remove('mega-nav__item--active');
            const l = i.querySelector('.mega-nav__link');
            if (l) l.setAttribute('aria-expanded', 'false');
          });
          if (!isActive) {
            item.classList.add('mega-nav__item--active');
            link.setAttribute('aria-expanded', 'true');
          }
        }
      });
    });
  }

  // Init mega nav when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaNav);
  } else {
    initMegaNav();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kleding-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  const faqSection = document.querySelector('.kleding-faq');
  if (!faqSection) return;

  const faqItems = faqSection.querySelectorAll('.kleding-faq__item');

  faqItems.forEach(item => {
    const question = item.querySelector('.kleding-faq__question');
    const answer = item.querySelector('.kleding-faq__answer');

    if (!question || !answer) return;

    question.addEventListener('click', () => {
      const isOpen = item.dataset.open === 'true';

      // Close all other FAQ items (accordion behavior)
      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.dataset.open = 'false';
          otherItem.querySelector('.kleding-faq__question')?.setAttribute('aria-expanded', 'false');
          const otherAnswer = otherItem.querySelector('.kleding-faq__answer');
          if (otherAnswer) otherAnswer.hidden = true;
        }
      });

      // Toggle current item
      item.dataset.open = isOpen ? 'false' : 'true';
      question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      answer.hidden = isOpen;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kleding-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  const pdp = document.querySelector('.kleding-pdp');
  if (!pdp) return;

  // === Gallery ===
  const imagesContainer = document.getElementById('kleding-images');
  const slides = imagesContainer?.querySelectorAll('.kleding-pdp__slide');
  const thumbs = document.querySelectorAll('.kleding-pdp__thumb');
  const thumbsContainer = document.getElementById('kleding-thumbs');

  let currentIndex = 0;
  const total = slides?.length || 0;

  function goToSlide(index) {
    if (!slides || total === 0) return;
    currentIndex = (index + total) % total;
    imagesContainer.scrollTo({
      left: currentIndex * slides[0].offsetWidth,
      behavior: 'smooth'
    });
    thumbs.forEach((t, i) => t.classList.toggle('kleding-pdp__thumb--active', i === currentIndex));
  }

  // Main image arrows
  document.querySelector('.kleding-pdp__arrow--left')?.addEventListener('click', () => goToSlide(currentIndex - 1));
  document.querySelector('.kleding-pdp__arrow--right')?.addEventListener('click', () => goToSlide(currentIndex + 1));

  // Thumbnail clicks
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goToSlide(i)));

  // Thumbnail arrows
  const thumbArrowLeft = document.querySelector('.kleding-pdp__thumb-arrow--left');
  const thumbArrowRight = document.querySelector('.kleding-pdp__thumb-arrow--right');

  function getThumbScrollAmount() {
    const firstThumb = thumbsContainer?.querySelector('.kleding-pdp__thumb');
    if (!firstThumb) return 62; // fallback
    return firstThumb.offsetWidth + 6; // width + gap
  }

  function updateThumbArrows() {
    if (!thumbsContainer) return;
    const maxScroll = thumbsContainer.scrollWidth - thumbsContainer.clientWidth;
    if (thumbArrowLeft) thumbArrowLeft.disabled = thumbsContainer.scrollLeft <= 0;
    if (thumbArrowRight) thumbArrowRight.disabled = thumbsContainer.scrollLeft >= maxScroll - 1;
  }

  thumbArrowLeft?.addEventListener('click', () => {
    thumbsContainer?.scrollBy({ left: -getThumbScrollAmount(), behavior: 'smooth' });
    setTimeout(updateThumbArrows, 350);
  });
  thumbArrowRight?.addEventListener('click', () => {
    thumbsContainer?.scrollBy({ left: getThumbScrollAmount(), behavior: 'smooth' });
    setTimeout(updateThumbArrows, 350);
  });

  // Initial arrow state
  setTimeout(updateThumbArrows, 100);

  // Sync on scroll
  let scrollTimeout;
  imagesContainer?.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      const newIndex = Math.round(imagesContainer.scrollLeft / slides[0].offsetWidth);
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        thumbs.forEach((t, i) => t.classList.toggle('kleding-pdp__thumb--active', i === currentIndex));
      }
    }, 50);
  });

  // === Quantity ===
  document.querySelectorAll('.kleding-pdp__qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.kleding-pdp__qty-input');
      if (!input) return;
      const val = parseInt(input.value) || 1;
      const max = parseInt(input.max) || 99;
      if (btn.dataset.action === 'decrease' && val > 1) {
        input.value = val - 1;
      } else if (btn.dataset.action === 'increase' && val < max) {
        input.value = val + 1;
      }
    });
  });

  // === Variant Selection ===
  const variantSelects = document.querySelectorAll('.kleding-pdp__variant-select');
  const productDataEl = document.getElementById('kleding-variants-json');

  if (variantSelects.length && productDataEl) {
    let productData;
    try {
      productData = JSON.parse(productDataEl.textContent);
    } catch (e) {
      console.error('Error parsing product data:', e);
    }

    if (productData) {
      function getSelectedOptions() {
        return Array.from(variantSelects).map(s => s.value);
      }

      function findVariant(opts) {
        return productData.variants.find(v =>
          v.options.every((opt, idx) => opt === opts[idx])
        );
      }

      function formatPrice(cents) {
        const euros = cents / 100;
        return euros % 1 === 0
          ? '€ ' + euros.toFixed(0) + ',-'
          : '€ ' + euros.toFixed(2).replace('.', ',');
      }

      function updateUrgency(variant) {
        const container = document.getElementById('kleding-urgency');
        if (!container) return;

        const stock = variant.inventory_quantity || 999;
        var html = '';

        if (variant.available) {
          var cls = 'kleding-pdp__urgency';
          var icon, text;

          if (stock === 1) {
            cls += ' kleding-pdp__urgency--critical';
            icon = '<svg class="kleding-pdp__urgency-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>';
            text = '<strong>Laatste exemplaar</strong> — direct uit voorraad';
          } else if (stock <= 3) {
            cls += ' kleding-pdp__urgency--low';
            icon = '<svg class="kleding-pdp__urgency-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>';
            text = '<strong>Nog ' + stock + ' beschikbaar</strong> — op is op';
          } else {
            icon = '<svg class="kleding-pdp__urgency-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';
            text = 'Op voorraad';
          }

          html = '<div class="' + cls + '">' + icon + '<span>' + text + '</span></div>';
        } else {
          html = '<div class="kleding-pdp__urgency kleding-pdp__urgency--soldout">'
            + '<svg class="kleding-pdp__urgency-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>'
            + '<span>Uitverkocht</span></div>';
        }

        container.innerHTML = html;
      }

      function onVariantChange() {
        const variant = findVariant(getSelectedOptions());
        if (!variant) return;

        const stock = variant.inventory_quantity || 999;
        const hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;

        // Update hidden inputs
        document.querySelectorAll('.kleding-pdp__variant-id').forEach(input => {
          input.value = variant.id;
        });

        // Update labels
        variantSelects.forEach((select, idx) => {
          const label = select.closest('.kleding-pdp__variant-group')?.querySelector('.kleding-pdp__variant-label strong');
          if (label) label.textContent = select.value;
        });

        // Update urgency/stock block
        updateUrgency(variant);

        // Update discount badge
        const badge = document.querySelector('.kleding-pdp__discount-badge');
        if (hasDiscount) {
          const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          if (badge) {
            badge.textContent = '-' + pct + '%';
            badge.style.display = '';
          }
        } else if (badge) {
          badge.style.display = 'none';
        }

        // Update prices
        document.querySelectorAll('.kleding-pdp__price, .kleding-pdp__sticky-current').forEach(el => {
          el.textContent = formatPrice(variant.price);
          el.classList.toggle('kleding-pdp__price--sale', hasDiscount);
        });

        // Update compare price & savings
        const compareEl = document.querySelector('.kleding-pdp__price-compare');
        const saveEl = document.querySelector('.kleding-pdp__price-save');
        const stickyWas = document.querySelector('.kleding-pdp__sticky-was');
        if (hasDiscount) {
          const savings = variant.compare_at_price - variant.price;
          if (compareEl) { compareEl.textContent = formatPrice(variant.compare_at_price); compareEl.style.display = ''; }
          if (saveEl) { saveEl.textContent = 'Bespaar ' + formatPrice(savings); saveEl.style.display = ''; }
          if (stickyWas) { stickyWas.textContent = formatPrice(variant.compare_at_price); stickyWas.style.display = ''; }
        } else {
          if (compareEl) compareEl.style.display = 'none';
          if (saveEl) saveEl.style.display = 'none';
          if (stickyWas) stickyWas.style.display = 'none';
        }

        // Update quantity max
        document.querySelectorAll('.kleding-pdp__qty-input').forEach(input => {
          input.max = variant.available ? stock : 0;
          if (parseInt(input.value) > stock) input.value = stock;
        });

        // Determine button text based on stock
        const buttonText = variant.available
          ? (stock === 1 ? 'Bestel nu' : 'Deze wil ik')
          : 'Uitverkocht';

        // Update buttons
        const addBtns = document.querySelectorAll('.kleding-pdp__add-btn, .kleding-pdp__sticky-btn');
        addBtns.forEach(btn => {
          btn.disabled = !variant.available;
          btn.dataset.textDefault = buttonText;

          const btnText = btn.querySelector('.kleding-pdp__btn-text');
          if (btnText) {
            btnText.textContent = buttonText;
          } else {
            btn.textContent = buttonText;
          }
        });

        // Switch to variant image if available
        if (variant.featured_image_id && typeof goToSlide === 'function') {
          const targetSlide = imagesContainer?.querySelector('[data-image-id="' + variant.featured_image_id + '"]');
          if (targetSlide) {
            goToSlide(parseInt(targetSlide.dataset.index));
          }
        }

        // Toggle packaging visibility by variant
        document.querySelectorAll('.kleding-pdp__packaging-pill[data-variant-id]').forEach(el => {
          el.hidden = el.dataset.variantId !== String(variant.id);
        });

        // Toggle remarks visibility by variant
        document.querySelectorAll('.kleding-pdp__remarks-box[data-variant-id]').forEach(el => {
          el.hidden = el.dataset.variantId !== String(variant.id);
        });

        // Update URL
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      variantSelects.forEach(select => select.addEventListener('change', onVariantChange));
    }
  }

  // === AJAX Add to Cart ===
  document.querySelectorAll('.kleding-pdp__form, .kleding-pdp__sticky-form').forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      const btn = form.querySelector('.kleding-pdp__add-btn, .kleding-pdp__sticky-btn');
      if (!btn || btn.disabled) return;

      // Get original text from data attribute (stock-dependent text)
      const originalText = btn.dataset.textDefault || btn.textContent.trim();
      const btnText = btn.querySelector('.kleding-pdp__btn-text');

      btn.disabled = true;
      if (btnText) {
        btnText.textContent = 'Bezig...';
      } else {
        btn.textContent = 'Bezig...';
      }

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity'), 10) || 1
          })
        });

        if (!response.ok) throw new Error('Add to cart failed');

        // Report the add to the OpenAI (ChatGPT ads) pixel
        if (typeof oaiq === 'function') oaiq('measure', 'items_added', { type: 'contents' });

        // Show success - button stays orange
        if (btnText) {
          btnText.textContent = 'Toegevoegd ✓';
        } else {
          btn.textContent = 'Toegevoegd ✓';
        }

        // Open cart drawer if available
        if (window.cartDrawer) {
          await window.cartDrawer.refreshCart();
          window.cartDrawer.open();
        }

        setTimeout(() => {
          btn.disabled = false;
          if (btnText) {
            btnText.textContent = originalText;
          } else {
            btn.textContent = originalText;
          }
        }, 2000);

      } catch (error) {
        console.error('Add to cart error:', error);
        btn.disabled = false;
        if (btnText) {
          btnText.textContent = originalText;
        } else {
          btn.textContent = originalText;
        }
      }
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kleding-recommendations"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initRecommendationsScroll() {
    const recScroll = document.getElementById('kleding-rec-scroll');
    const recArrowLeft = document.querySelector('.kleding-recommendations__arrow--left');
    const recArrowRight = document.querySelector('.kleding-recommendations__arrow--right');

    if (!recScroll || !recArrowLeft || !recArrowRight) return;

    function getScrollAmount() {
      const card = recScroll.querySelector('.kleding-recommendations__card');
      return card ? card.offsetWidth + 16 : 200;
    }

    function updateRecArrows() {
      const maxScroll = recScroll.scrollWidth - recScroll.clientWidth;
      recArrowLeft.disabled = recScroll.scrollLeft <= 0;
      recArrowRight.disabled = recScroll.scrollLeft >= maxScroll - 1;
    }

    recArrowLeft.addEventListener('click', () => {
      recScroll.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
      setTimeout(updateRecArrows, 350);
    });

    recArrowRight.addEventListener('click', () => {
      recScroll.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
      setTimeout(updateRecArrows, 350);
    });

    recScroll.addEventListener('scroll', () => {
      clearTimeout(recScroll.scrollTimeout);
      recScroll.scrollTimeout = setTimeout(updateRecArrows, 100);
    });

    updateRecArrows();
  }

  // Async load recommendations if using automatic mode
  const recsContainer = document.getElementById('kleding-recommendations');
  if (recsContainer?.dataset.url) {
    fetch(recsContainer.dataset.url)
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newRecs = doc.getElementById('kleding-recommendations');
        if (newRecs?.innerHTML.trim()) {
          recsContainer.innerHTML = newRecs.innerHTML;
          initRecommendationsScroll();
        }
      })
      .catch(console.error);
  }

  // Initialize scroll if already loaded (collection mode)
  initRecommendationsScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
(function() {
  // FAQ Accordion
  const faqItems = document.querySelectorAll('.pdp__faq-item');
  if (faqItems.length === 0) return;

  faqItems.forEach(item => {
    const question = item.querySelector('.pdp__faq-question');
    const answer = item.querySelector('.pdp__faq-answer');

    if (!question || !answer) return;

    question.addEventListener('click', () => {
      const isOpen = item.dataset.open === 'true';

      // Close all other FAQ items (accordion behavior)
      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.dataset.open = 'false';
          otherItem.querySelector('.pdp__faq-question')?.setAttribute('aria-expanded', 'false');
          const otherAnswer = otherItem.querySelector('.pdp__faq-answer');
          if (otherAnswer) otherAnswer.hidden = true;
        }
      });

      // Toggle current item
      item.dataset.open = isOpen ? 'false' : 'true';
      question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      answer.hidden = isOpen;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
(function() {
  const pdp = document.querySelector('.pdp');
  if (!pdp) return;

  const imagesContainer = document.getElementById('pdp-images');
  const slides = imagesContainer?.querySelectorAll('.pdp__slide');
  const thumbs = document.querySelectorAll('.pdp__thumb');
  const thumbsContainer = document.getElementById('pdp-thumbs');

  let currentIndex = 0;
  const total = slides?.length || 0;

  function goTo(index) {
    if (!slides || total === 0) return;
    currentIndex = (index + total) % total;
    imagesContainer.scrollTo({ left: currentIndex * slides[0].offsetWidth, behavior: 'smooth' });
    thumbs.forEach((t, i) => t.classList.toggle('pdp__thumb--active', i === currentIndex));
  }

  // Main arrows
  document.querySelector('.pdp__arrow--left')?.addEventListener('click', () => goTo(currentIndex - 1));
  document.querySelector('.pdp__arrow--right')?.addEventListener('click', () => goTo(currentIndex + 1));

  // Thumb arrows - scroll by one thumbnail width + gap
  const thumbArrowLeft = document.querySelector('.pdp__thumb-arrow--left');
  const thumbArrowRight = document.querySelector('.pdp__thumb-arrow--right');

  function getThumbScrollAmount() {
    const firstThumb = thumbsContainer?.querySelector('.pdp__thumb');
    if (!firstThumb) return 78; // fallback
    return firstThumb.offsetWidth + 6; // width + gap
  }

  function updateThumbArrows() {
    if (!thumbsContainer) return;
    const maxScroll = thumbsContainer.scrollWidth - thumbsContainer.clientWidth;
    if (thumbArrowLeft) thumbArrowLeft.disabled = thumbsContainer.scrollLeft <= 0;
    if (thumbArrowRight) thumbArrowRight.disabled = thumbsContainer.scrollLeft >= maxScroll - 1;
  }

  thumbArrowLeft?.addEventListener('click', () => {
    thumbsContainer?.scrollBy({ left: -getThumbScrollAmount(), behavior: 'smooth' });
    setTimeout(updateThumbArrows, 350);
  });
  thumbArrowRight?.addEventListener('click', () => {
    thumbsContainer?.scrollBy({ left: getThumbScrollAmount(), behavior: 'smooth' });
    setTimeout(updateThumbArrows, 350);
  });

  // Initial arrow state
  setTimeout(updateThumbArrows, 100);

  // Thumb clicks
  thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));

  // Scroll sync
  let timeout;
  imagesContainer?.addEventListener('scroll', () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      const newIndex = Math.round(imagesContainer.scrollLeft / slides[0].offsetWidth);
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        thumbs.forEach((t, i) => t.classList.toggle('pdp__thumb--active', i === currentIndex));
      }
    }, 50);
  });

  // Quantity buttons
  document.querySelectorAll('.pdp__qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.pdp__qty-input');
      if (!input) return;
      const val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'decrease' && val > 1) input.value = val - 1;
      else if (btn.dataset.action === 'increase') input.value = val + 1;
    });
  });

  // Description toggle
  const descToggle = document.querySelector('.pdp__description-toggle');
  const descWrapper = document.querySelector('.pdp__description-wrapper');
  const descToggleText = document.querySelector('.pdp__description-toggle-text');

  if (descToggle && descWrapper) {
    descToggle.addEventListener('click', () => {
      const isExpanded = descToggle.dataset.expanded === 'true';
      descToggle.dataset.expanded = !isExpanded;
      descWrapper.dataset.collapsed = isExpanded;
      descToggleText.textContent = isExpanded ? descToggle.dataset.showText : descToggle.dataset.hideText;
    });
  }

  // Variant selection handling
  const variantSelects = document.querySelectorAll('.pdp__variant-select');
  const productDataEl = document.getElementById('product-variants-json');

  if (variantSelects.length > 0 && productDataEl) {
    let productData;
    try {
      productData = JSON.parse(productDataEl.textContent);
    } catch (e) {
      console.error('Error parsing product data:', e);
    }

    if (productData) {
      // Get selected options from all selects
      function getSelectedOptions() {
        const options = [];
        variantSelects.forEach(select => {
          options.push(select.value);
        });
        return options;
      }

      // Find variant matching selected options
      function findVariant(selectedOptions) {
        return productData.variants.find(variant => {
          return variant.options.every((opt, idx) => opt === selectedOptions[idx]);
        });
      }

      // Find image index by image ID
      function findImageIndexById(imageId) {
        if (!imageId) return -1;
        const slide = imagesContainer?.querySelector(`[data-image-id="${imageId}"]`);
        if (slide) {
          return parseInt(slide.dataset.index, 10);
        }
        return -1;
      }

      // Format price for display
      function formatPrice(cents) {
        const euros = cents / 100;
        if (euros % 1 === 0) {
          return '€ ' + euros.toFixed(0) + ',-';
        }
        return '€ ' + euros.toFixed(2).replace('.', ',');
      }

      // Update all elements when variant changes
      function onVariantChange() {
        const selectedOptions = getSelectedOptions();
        const variant = findVariant(selectedOptions);

        if (!variant) return;

        // Update hidden variant ID inputs in all forms
        document.querySelectorAll('.pdp__variant-id').forEach(input => {
          input.value = variant.id;
        });

        // Update option labels to show selected value
        variantSelects.forEach((select, idx) => {
          const label = document.getElementById(`pdp-option-label-${idx}`);
          if (label) {
            const valueSpan = label.querySelector('.pdp__option-value');
            if (valueSpan) {
              valueSpan.textContent = select.value;
            }
          }
        });

        // Update add to cart buttons
        document.querySelectorAll('.pdp__add-btn, .pdp__sticky-btn').forEach(btn => {
          const btnText = btn.querySelector('.pdp__btn-text');
          if (variant.available) {
            btn.disabled = false;
            if (btnText) btnText.textContent = btn.dataset.addText || 'In winkelwagen';
          } else {
            btn.disabled = true;
            if (btnText) btnText.textContent = btn.dataset.soldOutText || 'Te laat';
          }
        });

        // Update prices
        const priceEls = document.querySelectorAll('.pdp__price, .pdp__sticky-amount');
        priceEls.forEach(el => {
          el.textContent = formatPrice(variant.price);
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            el.classList.add('pdp__price--sale');
          } else {
            el.classList.remove('pdp__price--sale');
          }
        });

        // Update compare at prices
        const compareEls = document.querySelectorAll('.pdp__compare-price, .pdp__sticky-was');
        compareEls.forEach(el => {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            el.textContent = formatPrice(variant.compare_at_price);
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });

        // Update compare labels
        document.querySelectorAll('.pdp__compare-label, .pdp__sticky-compare-label').forEach(el => {
          el.style.display = (variant.compare_at_price && variant.compare_at_price > variant.price) ? '' : 'none';
        });

        // Update savings badges
        document.querySelectorAll('.pdp__savings-badge').forEach(el => {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            const sav = variant.compare_at_price - variant.price;
            const pct = Math.round((sav / variant.compare_at_price) * 100);
            const tpl = el.dataset.template || '';
            el.textContent = tpl.replace('__AMOUNT__', formatPrice(sav)).replace('__PERCENTAGE__', pct);
            el.style.display = '';
          } else {
            el.style.display = 'none';
          }
        });

        // Update discount badge on image
        const discountBadge = document.querySelector('.pdp__discount');
        if (discountBadge) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            const pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            discountBadge.textContent = '-' + pct + '%';
            discountBadge.style.display = '';
          } else {
            discountBadge.style.display = 'none';
          }
        }

        // Toggle quantity selector based on inventory
        const shouldShowQty = !variant.inventory_management
          || variant.inventory_policy === 'continue'
          || variant.inventory_quantity > 1;
        document.querySelectorAll('.pdp__qty-row').forEach(el => {
          el.classList.toggle('pdp__qty-row--hidden', !shouldShowQty);
          if (!shouldShowQty) {
            const qtyInput = el.querySelector('.pdp__qty-input');
            if (qtyInput) qtyInput.value = 1;
          }
        });
        document.querySelectorAll('.pdp__add-btn').forEach(el => {
          el.classList.toggle('pdp__add-btn--full', !shouldShowQty);
        });

        // Switch to variant's featured image
        if (variant.featured_image_id) {
          const imageIndex = findImageIndexById(variant.featured_image_id);
          if (imageIndex >= 0 && imageIndex !== currentIndex) {
            goTo(imageIndex);
          }
        }

        // Toggle packaging visibility by variant
        document.querySelectorAll('.pdp__packaging-pill[data-variant-id]').forEach(el => {
          el.hidden = el.dataset.variantId !== String(variant.id);
        });

        // Toggle remarks visibility by variant
        document.querySelectorAll('.pdp__remarks-box[data-variant-id]').forEach(el => {
          el.hidden = el.dataset.variantId !== String(variant.id);
        });

        // Update browser URL without page reload
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      // Attach event listeners to variant selects
      variantSelects.forEach(select => {
        select.addEventListener('change', onVariantChange);
      });
    }
  }

  // Product Recommendations - async loading
  const recommendationsContainer = document.getElementById('product-recommendations');
  if (recommendationsContainer && recommendationsContainer.dataset.url) {
    fetch(recommendationsContainer.dataset.url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const recommendations = doc.getElementById('product-recommendations');
        if (recommendations && recommendations.innerHTML.trim()) {
          recommendationsContainer.innerHTML = recommendations.innerHTML;
          initRecommendationsScroll();
        }
      })
      .catch(err => console.error('Error loading recommendations:', err));
  }

  // Recommendations scroll arrows
  function initRecommendationsScroll() {
    const recScroll = document.getElementById('rec-scroll');
    const recArrowLeft = document.querySelector('.pdp__rec-arrow--left');
    const recArrowRight = document.querySelector('.pdp__rec-arrow--right');

    if (!recScroll || !recArrowLeft || !recArrowRight) return;

    function getScrollAmount() {
      const card = recScroll.querySelector('.pdp__rec-card');
      return card ? card.offsetWidth + 16 : 200;
    }

    function updateRecArrows() {
      const maxScroll = recScroll.scrollWidth - recScroll.clientWidth;
      recArrowLeft.disabled = recScroll.scrollLeft <= 0;
      recArrowRight.disabled = recScroll.scrollLeft >= maxScroll - 1;
    }

    recArrowLeft.addEventListener('click', () => {
      recScroll.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
      setTimeout(updateRecArrows, 350);
    });

    recArrowRight.addEventListener('click', () => {
      recScroll.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
      setTimeout(updateRecArrows, 350);
    });

    recScroll.addEventListener('scroll', () => {
      clearTimeout(recScroll.scrollTimeout);
      recScroll.scrollTimeout = setTimeout(updateRecArrows, 100);
    });

    updateRecArrows();
  }

  // FAQ Accordion
  const faqItems = document.querySelectorAll('.pdp__faq-item');
  faqItems.forEach(item => {
    const question = item.querySelector('.pdp__faq-question');
    const answer = item.querySelector('.pdp__faq-answer');

    if (!question || !answer) return;

    question.addEventListener('click', () => {
      const isOpen = item.dataset.open === 'true';

      // Close all other FAQ items (accordion behavior)
      faqItems.forEach(otherItem => {
        if (otherItem !== item) {
          otherItem.dataset.open = 'false';
          otherItem.querySelector('.pdp__faq-question')?.setAttribute('aria-expanded', 'false');
          const otherAnswer = otherItem.querySelector('.pdp__faq-answer');
          if (otherAnswer) otherAnswer.hidden = true;
        }
      });

      // Toggle current item
      item.dataset.open = isOpen ? 'false' : 'true';
      question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      answer.hidden = isOpen;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
